exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-footer {\r\n    display: block;\r\n}\r\n\r\n.jarviswidget.well header {\r\n    display: block;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis.component.css
// module id = ../../../../../src/app/mis/mis.component.css
// module chunks = main